import React from 'react';
import _ from 'lodash';
import Router from 'next/router';
import App, { AppProps } from 'next/app';
import ReactBreakpoints from 'react-breakpoints';
import { withRouter } from 'next/router';
import cookie from 'js-cookie';
import nextCookie from 'next-cookies';
import { saveScroll, restoreScroll } from 'src/utils/saveScroll';
import { replaceWalterKnollUSA } from 'src/modules/locale/utils';
import {
  getOutputChannel,
  getDomainUrl,
} from 'src/modules/locale/components/Provider/outputChannel';
import { Cookies } from 'src/modules/cookies';

import { wrapper } from '../store';
import NProgress from 'nprogress';

import addFontsComScript from 'src/utils/addFontsDotComScript';

// import 'src/styles/antd.less';
import 'src/styles/app.scss';
import 'src/styles/ant.scss';
import 'src/styles/nprogress.css';
// import 'react-intense/dist/ReactIntense.css';
// import 'react-intense/dist/loader.css';
import { breakpoints } from 'src/utils/breakpoints';

import { AppEnvironments } from 'src/utils/types/env';
import { ErrorBoundary } from 'src/modules/global';
import { LocaleProvider, getMessages, setOnlineChannel } from 'src/modules/locale';
import { OutputChannels } from 'src/modules/locale';
// import { fetchHeaderData } from 'src/modules/layout';

if (typeof window === 'undefined') {
  // dom parser for FormatedHTMLMessages
  global.DOMParser = new (require('jsdom').JSDOM)().window.DOMParser; // eslint-disable-line
}

Router.events.on('routeChangeStart', (/* _url */) => {
  // console.log(`Loading: ${url}`);
  NProgress.start();
});
Router.events.on('routeChangeComplete', () => NProgress.done());
Router.events.on('routeChangeError', () => NProgress.done());

// interface GtmIds {
//   analytic: { walterk_ga: string; walterknoll_ga: string };
// }

interface WkAppProps extends AppProps {
  locale: string;
  origin: string;
  messages: any;
  initialState: any;
  // gtmIds: { analytic: { walterk_ga: string; walterknoll_ga: string } };
  appEnv: AppEnvironments;
  access: string | boolean;
  onlineChannel: string;
}

interface WkAppStateProps {
  access: string | boolean;
  password: string;
}

class WkApp extends App<WkAppProps, any, WkAppStateProps> {
  constructor(props: WkAppProps) {
    super(props);
    this.state = {
      // access: process.env.NEXT_PUBLIC_APP_ENV === AppEnvironments.Test ? this.props.access : true,
      access: true,
      password: '',
    };
  }

  static async getInitialProps({ Component, ctx, router }) {
    const origin = getDomainUrl();

    try {
      let pageProps = {};

      if (Component.getInitialProps) {
        pageProps = await Component.getInitialProps(ctx);
      }

      const onlineChannel = getOutputChannel() as OutputChannels;
      onlineChannel && setOnlineChannel(onlineChannel)(ctx.store.dispatch);

      let messages = await getMessages(router.locale);
      if (onlineChannel === OutputChannels.US) {
        messages = _.mapValues(messages, (message: string) => {
          return replaceWalterKnollUSA(message, onlineChannel);
        });
      }

      const access = nextCookie(ctx).access;

      return {
        pageProps,
        locale: router.locale,
        messages,
        onlineChannel,
        appEnv: process.env.NEXT_PUBLIC_APP_ENV,
        dispatch: ctx.store.dispatch,
        access,
        origin,
      };
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  async componentDidMount() {
    window.history.scrollRestoration = 'manual';
    let cachedScroll: { sel: string; top: number; scrollY: number }[] = [];

    // (1) Browser back button
    Router.beforePopState(() => {
      Router.events.off('routeChangeStart', onRouteChangeStart);
      Router.events.on('routeChangeComplete', onRouteChangeComplete);

      return true;
    });

    // (2) Navigation starts - save scroll
    const onRouteChangeStart = () => cachedScroll.push(saveScroll());

    // (3) Navigation ends - restore scroll
    const onRouteChangeComplete = () => {
      if (!_.isEmpty(cachedScroll)) {
        restoreScroll(cachedScroll.pop());
        cachedScroll = [];
      }

      Router.events.off('routeChangeComplete', onRouteChangeComplete);
      Router.events.on('routeChangeStart', onRouteChangeStart);
    };

    Router.events.on('routeChangeStart', onRouteChangeStart);

    addFontsComScript();

    // if (!(typeof window === 'undefined')) {
    //   this.setState({ access: window.localStorage.getItem('access') });
    // }
    // console.log(this.props);
    // fetchHeaderData(this.props.onlineChannel as string)(this.props.dispatch);
    //Add GTM tags in production only
  }

  clickPassword() {
    if (this.state.password === 'walterknoll2021') {
      // localStorage.setItem('access', 'true');
      cookie.set('access', true, { expires: 15 });
      this.setState({ access: true });
    }
  }

  render() {
    const { Component, pageProps, locale, origin, messages } = this.props;

    return (
      <ReactBreakpoints breakpoints={breakpoints} debounceResize={true} debounceDelay={20}>
        <React.StrictMode>
          <ErrorBoundary>
            <LocaleProvider
              locale={locale}
              messages={messages}
              origin={origin}
              appEnv={this.props.appEnv}>
              <Cookies />
              <div>
                {!this.state.access && !this.props.access ? (
                  <div>
                    <input
                      type="password"
                      onChange={(pw) => {
                        this.setState({ password: pw.target.value });
                      }}
                    />
                    <button onClick={this.clickPassword.bind(this)}>send</button>
                  </div>
                ) : (
                  <Component {...pageProps} />
                )}
              </div>
            </LocaleProvider>
          </ErrorBoundary>
        </React.StrictMode>
      </ReactBreakpoints>
    );
  }
}

export default wrapper.withRedux(withRouter(WkApp));
